export default __webpack_public_path__ + "static/cars-57bd7a0646ec70ae91e954524ad38e3b.png";